export const localDocsRoutes = import.meta.env.DEV
  ? [
      {
        path: 'docs',
        component: () => import('@/features/superAdmin/localDocs/LocalDocsView.vue'),
        meta: {
          layoutPadding: false,
        },
      },
    ]
  : []
